import styled from 'styled-components'
import { colors } from "../../branding";

export const StyledArticle = styled.article`
  width: 100vw;
  background-color: ${colors.pale};
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
  margin-top: 50px;
  margin-bottom: -50px;
  
  
  >div {
    position: relative;
    top: -25px;
    width: var(--app-width);
    padding: 20px var(--content-padding-md);
    background-color: ${colors.light};
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    margin: 0 auto 50px;
    border-radius: 5px;
  }

  @media (max-width: 1040px) {
    >div {
      width: auto;
    }
  }
`
